import { render, staticRenderFns } from "./DistributedColumnChart.vue?vue&type=template&id=6a134236&"
import script from "./DistributedColumnChart.vue?vue&type=script&lang=js&"
export * from "./DistributedColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports